import { Heading, Image, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import banner from '~/assets/images/banner.png';

function Header() {
  const { t } = useTranslation('common');

  return (
    <Stack direction='column' alignItems='center' spacing={6}>
      <Heading fontFamily='heading' as='h1' fontSize='5rem' textAlign='center'>
        {t('karaokeCatalogue')}
      </Heading>

      <Text fontSize='15px' maxW='700px' textAlign='center' px={2}>
        {t('subtitle')}
      </Text>

      <Image
        src={`${location.origin}${import.meta.env.VITE_PUBLIC_URL}${banner}`}
        objectFit='cover'
        overflow={'hidden'}
        w={'100%'}
        h={{ base: 250, lg: 313 }}
      />
    </Stack>
  );
}
export default Header;
